module.exports = __webpack_public_path__ + "static/media/running.f5f9f5a2.png";